import { Table, Text } from '@quintoandar-tokko/jopijs';
import styles from '../dashboardTables.module.scss';
import ContactCell from '../components/ContactCell';
import AgentBranchCell from '../components/AgentBranchCell';

export default function ConversionTimeTableRow({ row }) {
  const {
    id,
    contact,
    agent,
    branch,
    conversion_time,
    property_type,
    location,
    operation,
    value,
  } = row;

  return (
    <Table.RowDefault id={id} variant="secondary">
      <Table.RowItemDefault
        variant="secondary"
        className={styles.tableBodyCell}
      >
        <AgentBranchCell
          agentId={agent?.id}
          agentName={agent?.name}
          image={agent?.profile_picture}
          branchName={branch.name}
          relativeSelector="#conversion-time-modal"
          withImage
          withBoldTitle
          withBranch
          modal="conversionTime"
        />
      </Table.RowItemDefault>

      <Table.RowItemDefault
        variant="secondary"
        className={styles.tableBodyCell}
      >
        <Text variant="body.fontSize13">{conversion_time}</Text>
      </Table.RowItemDefault>

      <Table.RowItemDefault
        variant="secondary"
        className={styles.tableBodyCell}
      >
        <ContactCell
          highlighted={false}
          id={contact?.id}
          cellphone={contact?.cellphone}
          name={contact?.name}
          email={contact?.email}
          image={contact?.image}
          leadStatus={contact?.lead_status}
          agent={contact}
          relativeSelector="#conversion-time-modal"
          modal="conversionTime"
        />
      </Table.RowItemDefault>

      <Table.RowItemDefault
        variant="secondary"
        className={styles.tableBodyCell}
      >
        <Text variant="body.fontSize13">{property_type?.label}</Text>
      </Table.RowItemDefault>

      <Table.RowItemDefault
        variant="secondary"
        className={styles.tableBodyCell}
      >
        <Text variant="body.fontSize13">{location}</Text>
      </Table.RowItemDefault>

      <Table.RowItemDefault
        variant="secondary"
        className={styles.tableBodyCell}
      >
        <Text variant="body.fontSize13">{operation?.label}</Text>
      </Table.RowItemDefault>

      <Table.RowItemDefault
        variant="secondary"
        className={styles.tableBodyCell}
      >
        <Text variant="body.fontSize13">{value}</Text>
      </Table.RowItemDefault>
    </Table.RowDefault>
  );
}
